import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=41b81f5b&scoped=true&"
import script from "./UserRoles.vue?vue&type=script&lang=js&"
export * from "./UserRoles.vue?vue&type=script&lang=js&"
import style0 from "./UserRoles.vue?vue&type=style&index=0&id=41b81f5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b81f5b",
  null
  
)

export default component.exports